export const COLORS = {
  "1": "blue",
  "2": "green",
  "3": "red",
  "4": "purple",
  "5": "orange",
  "6": "teal",
  "7": "black",
  "8": "gray",
};
